<template>
    <p>Hello this is investment Detail page</p>
</template>